/*!
 *  (c)(r) 2008-2023 IT-Service Robert Frunzke
 */

/**
 * Format a number to a fixed number of decimal places, padded with leading zeroes.
 *
 * - Result is the same as when using sprintf with '%0nd' (where n is number of decimal places).
 * - When input is negative, then "minus sign" is always prepended and actual number of decimal places is decreased by one.
 * - When input is not representable in the number of decimal places, then result contains the full number.
 *
 * @example
 * sprintf_0xd(12,3) === sprintf('%03d',12) === '012'
 *
 * @example
 * // When input is negative, then "minus sign" is always prepended and actual number of decimal places is decreased by one.
 * sprintf_0xd(-1,3)    === '-01'
 * sprintf_0xd(-12,3)   === '-12'
 * sprintf_0xd(-123,3)  === '-123'
 * sprintf_0xd(-123,6)  === '-00123'
 * sprintf_0xd(-1234,6) === '-01234'
 *
 *
 * @example
 * // When input is not representable in the number of decimal places, then result contains the full number.
 * sprintf_0xd(1,3)     === '001'
 * sprintf_0xd(12,3)    === '012'
 * sprintf_0xd(123,3)   === '123'
 * sprintf_0xd(1234,3)  === '1234'
 * sprintf_0xd(12345,3) === '12345'
 *
 * @example
 * for( let input of [ 1,12,123,1234,12345,123456, -1,-12,-123,-1234,-12345,-123456, null,undefined, 'a','ab','abc','abcdef', '1','12','123','1234','12345','123456' ] ) {
 *     console.log({ input, result: sprintf_0xd(input,3) });
 * }
 *
 * // result:
 * // {input: 1, result: "001"}
 * // {input: 12, result: "012"}
 * // {input: 123, result: "123"}
 * // {input: 1234, result: "1234"}
 * // {input: 12345, result: "12345"}
 * // {input: 123456, result: "123456"}
 * // {input: -1, result: "-01"}
 * // {input: -12, result: "-12"}
 * // {input: -123, result: "-123"}
 * // {input: -1234, result: "-1234"}
 * // {input: -12345, result: "-12345"}
 * // {input: -123456, result: "-123456"}
 * // {input: null, result: "000"}
 * // {input: undefined, result: "NaN"}
 * // {input: "a", result: "NaN"}
 * // {input: "ab", result: "NaN"}
 * // {input: "abc", result: "NaN"}
 * // {input: "abcdef", result: "NaN"}
 * // {input: "1", result: "001"}
 * // {input: "12", result: "012"}
 * // {input: "123", result: "123"}
 * // {input: "1234", result: "1234"}
 * // {input: "12345", result: "12345"}
 * // {input: "123456", result: "123456"}
 *
 * @param {number} i - input number
 * @param {number} d - number of decimal places
 * @returns {string}
 */
export function sprintf_0xd( i, d ) {
	var s = i<0 ? -1 : 1;
	var v = (s*i).toString();
	while( v.length < d ) v = '0'+v;
	return s===1 ? v : ( '-'+(v[0]==='0'?v.substr(1):v) );
}


/**
 * Format a number to three decimal places, padded with leading zeroes.
 *
 * - This function may produce surprising results:
 * - When input is not representable in three decimal places, then the most significant digits are removed.
 * - When input is negative, then the "minus sign" is always included.
 *
 * @param {number} i - input number
 * @returns {string} the formatted number
 *
 * @example
 * // When input is not representable in three decimal places, then the most significant digits are removed.
 * sprintf_0x3(1)      === '001'
 * sprintf_0x3(12)     === '012'
 * sprintf_0x3(123)    === '123'
 * sprintf_0x3(1234)   === '234'
 * sprintf_0x3(12345)  === '345'
 *
 * @example
 * // When input is negative, then the "minus sign" is always included.
 * sprintf_0x3(-1)     === '-01'
 * sprintf_0x3(-12)    === '-12'
 * sprintf_0x3(-123)   === '-123'
 * sprintf_0x3(-1234)  === '-234'
 * sprintf_0x3(-12345) === '-345'
 */
export function sprintf_0x3( i ) {
	if( i<0 ) {
		// negative int ..
		let v = ('00'+(-i)).slice(-3);
		return ( '-'+(v[0]==='0'?v.substr(1):v) );
	}
	// positive int ..
	return ('00'+i).slice(-3);
}

